import Image from 'next/image';
import styled from 'styled-components';
import { device } from '../../../../shared/styles/device';

const GridTwoCol = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1fr);

  @media ${device.tablet} {
    grid-template-columns: minmax(0, 2fr)  minmax(0, 3fr);
  }
`;

const HeroImageWrapper = styled.div`
  display: none;
  visibility: hidden;

  @media ${device.tablet} {
    visibility: visible;
    background-color: #18191F;
    display: flex;
    align-items: flex-start;
    position: relative;
    max-height: 100vh;
    border-radius: 0 0 64px 0;

    .hero-img {
      height: 100%;
      width: 100%;
      border-radius: 0 0 64px 0;
    }
  }
`;
const HeroTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: 16px;
    max-width: 100%;
    margin-right: 16px;
    padding-top: 32px;
  
    @media ${device.tablet} {
      margin-left: 42px;
      max-width: 576px;
      align-items: flex-start;
    }

    @media ${device.laptop} {
      max-width: 653px;
    }
`;

interface HeadlineProps {
  readonly primary?: boolean;
};

const Headline = styled.h1<HeadlineProps>`
    color: ${props => props.primary ? props.theme.colors.primary : props.theme.colors.fontBlack};
    line-height: 92px;
    margin-bottom: ${props => props.primary ? '32px' : '0px'};
    margin-top: 0;
    text-align: left;

    @media(max-width: 768px) {
        font-size: 36px;
        letter-spacing: -0.1rem;
        line-height: normal;
        margin-bottom: ${props => props.primary ? '32px' : '0px'};
    }
`;
const HeroText = styled.p`
    color: ${props => props.theme.colors.fontBlack};
    margin-bottom: 32px;
    margin-top: 0;
    font-size: 19px;
    line-height: 27px;
    font-weight: 500;
    letter-spacing: -0.01em;
    text-align: left;

  @media ${device.tablet} {
    font-size: 19px;
    line-height: 27px;
    font-weight: 500;
    letter-spacing: -0.01em;
  }
`;

export const HeroIntro = () => {
  return (
    <GridTwoCol>
      <HeroImageWrapper>
        <Image
          src="/images/aboutus/sme.jpg"
          alt="easyboarding Treffen Meeting"
          layout='fill'
          quality={100}
          className="hero-img"
          loading="eager"
          objectFit='cover'
          priority={true}
        />
      </HeroImageWrapper>
      <HeroTextWrapper>
        <Headline>Über das</Headline>
        <Headline primary><span>easyboarding</span></Headline>
        <HeroText>
          easyboarding ist eine Brancheninitiative von TRVL Counter und STELL-MICH-EIN, in Kooperation mit dem Deutschen Reiseverband (DRV). Im Jahr 2022 startet unsere Initiative im Tourismus durch. Dennoch kann man sagen, dass wir eine lange und erfolgreiche Geschichte hinter uns haben.
          <br /> <br />
          Denn easyboarding hat eine sehr erfolgreiche große Schwester. Seit 2012 vernetzt das STELL-MICH-EIN junge Talente mit Unternehmen der Kommunikationsbranche. In dieser Zeit haben wir über 18.000 Bewerbungen von jungen Talenten erhalten und knapp 600 Unternehmensanmeldungen gezählt.
          <br /> <br />
          Die Geschichte des STELL-MICH-EIN ist ohne Frage eine Erfolgsgeschichte. Und diese schreiben wir fort in der Touristik – und das mit einem starken Team.
          <br /> <br />
          Mit an Bord ist TRVL Counter, eine aufstrebende, innovative Medienmarke aus Hamburg, die bei Counterprofis, Reisebüro-Inhabern sowie Veranstaltern anerkannt ist.
          <br /> <br />
          Außerdem startet easyboarding in Kooperation mit dem DRV. Der Deutsche Reiseverband repräsentiert die Reisewirtschaft in Deutschland. Als einer der Spitzenverbände bündelt er die Interessen der Veranstalter, Reisebüros und Leistungsträger in Deutschland.
        </HeroText>
      </HeroTextWrapper>

    </GridTwoCol>
  )
}
